import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Box,
    Button,
    Center,
    Text,
    useDisclosure,
} from '@chakra-ui/react';
import { createRef } from 'react';
import { BiLock } from 'react-icons/bi';

export interface IHintProps {
    disabled?: boolean;
    locked?: boolean;
    lockMessage: JSX.Element;
    children?: JSX.Element;
    title: string;
    onClick: () => void;
}

export function Hint(props: IHintProps) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = createRef<HTMLButtonElement>();

    const disabledProps = {
        borderColor: 'gray.600',
        borderStyle: 'solid',
        borderWidth: 2,
        borderRadius: 'md',
        px: 6,
        py: 4,
        cursor: 'not-allowed',
        opacity: 0.3,
    };

    const lockedProps = {
        borderColor: 'gray.600',
        borderStyle: 'solid',
        borderWidth: 2,
        borderRadius: 'md',
        px: 6,
        py: 4,
        cursor: 'pointer',
        _hover: {
            background: 'gray.600',
        },
    };

    const unlockedProps = {
        borderColor: 'gray.600',
        borderStyle: 'dashed',
        borderWidth: 2,
        borderRadius: 'md',
        px: 6,
        py: 4,
    };

    if (props.children) {
        return (
            <Box {...unlockedProps}>
                <Text as="h3" fontSize="l" fontWeight="bold" mb={2} onClick={props.onClick}>
                    {props.title}
                </Text>
                <Text>{props.children}</Text>
            </Box>
        );
    }

    return (
        <>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
                <AlertDialogOverlay>
                    <AlertDialogContent color="gray.200">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Vyzvednout nápovědu
                        </AlertDialogHeader>

                        <AlertDialogBody>Opravdu si chcete vyzvednout nápovědu?</AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button
                                colorScheme="blue"
                                onClick={() => {
                                    onClose();
                                    props.onClick();
                                }}
                                ml={3}
                            >
                                Vyzvednout
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            <Box {...(props.disabled ? disabledProps : lockedProps)} onClick={props.disabled ? () => {} : onOpen}>
                <Text as="h3" fontSize="l" fontWeight="bold" mb={2}>
                    {props.title}
                </Text>
                <Center my={6} fontSize="3xl">
                    <BiLock />
                </Center>
                <Text color="gray.400">{props.lockMessage}</Text>
            </Box>
        </>
    );
}
